import React, { useState } from 'react'
import styled from 'styled-components'

import { Row } from '@zendeskgarden/react-grid'
import { Modal, Close } from '@zendeskgarden/react-modals'
import { Tooltip, Title } from '@zendeskgarden/react-tooltips'
import { MD } from '@zendeskgarden/react-typography'
import { Button } from '@zendeskgarden/react-buttons'

import IncidentModalContent from './IncidentModalContent'
import StatusIcon from './StatusIcon'
import { decideIncidentStatus, localizeIncidentTimestamp } from '../../utils/incident'

const StyledTooltipIconDiv = styled.div`
  margin-right: 5px
  margin-top: 11px
`

const StyledTooltipTitleDiv = styled.div`
  margin-top: 10px
  text-align: left
  width: 90%
`

const StyledDetailsDiv = styled.div`
  display: flex
  justify-content: space-around
  margin-top: 10px
  margin-bottom: 10px
`

const StyledDurationDiv = styled.div`
  margin-top: 10px
`


const TooltipDuration = ({ startedAt, resolvedAt, inTimezone }) => {
  return (
    <div>
      <Row justifyContent="start">
        <MD>{`Started: ${localizeIncidentTimestamp(startedAt, inTimezone)}`}</MD>
      </Row>
      <Row justifyContent="start">
        <MD>{`Resolved: ${localizeIncidentTimestamp(resolvedAt, inTimezone)}`}</MD>
      </Row>
    </div>
  )
}

const MockTooltip = ({ incidents, incidentServices = [], serviceId, children, inTimezone }) => {
  const [modalIncident, setModalIncident] = useState(null)

  const incidentService = incident => { return incidentServices.filter(i => i.attributes.serviceId.toString() === serviceId && i.attributes.incidentId.toString() === incident.id)[0] }
  const incidentServiceStartedAt = incident => { return incidentService(incident).attributes.startedAt }
  const incidentServiceResolvedAt = incident => { return incidentService(incident).attributes.resolvedAt }

  const onModalClose = () => {
    setModalIncident(null)
  }

  if (!modalIncident) {
    return (
      <Tooltip
        type="light"
        placement="top"
        size="extra-large"
        zIndex="1000"
        trigger={children}
      >
        {incidents.map(incident => {
          return (
            <div key={incident.id}>
              <Row>
                <StyledTooltipIconDiv>
                  <StatusIcon status={decideIncidentStatus(incidentService(incident) && incidentService(incident).attributes ? incidentService(incident).attributes : incident.attributes)}/>
                </StyledTooltipIconDiv>
                <StyledTooltipTitleDiv>
                  <Title>{incident.attributes.name}</Title>
                </StyledTooltipTitleDiv>
              </Row>
              <StyledDurationDiv>
                <TooltipDuration
                  startedAt={incidentServiceStartedAt(incident)}
                  resolvedAt={incidentServiceResolvedAt(incident)}
                  inTimezone={inTimezone}
                />
              </StyledDurationDiv>
              <StyledDetailsDiv>
                <Button onClick={() => {setModalIncident(incident)}} link>View details</Button>
              </StyledDetailsDiv>
            </div>
          )
        })}
      </Tooltip>
    )
  }
  return (
    <Modal onClose={onModalClose} large animate>
      <IncidentModalContent
        key={`${modalIncident.id.toString()}`}
        incident={modalIncident}
        incidentService={incidentService(modalIncident)}
        inTimezone={inTimezone}
      >
      </IncidentModalContent>
      <Close aria-label="Close modal" />
    </Modal>
  )
}

export default MockTooltip
